import { createActions } from 'redux-actions'

export const {
  getBlogStatusStatisticsRequest,
  getBlogStatusStatisticsSucceed,
  getBlogListRequest,
  getBlogListSucceed,
  getBlogDetailRequest,
  getBlogDetailSucceed,
  createBlogRequest,
  createBlogSucceed,
  updateBlogRequest,
  updateBlogSucceed,
  updateBlogStatusRequest,
  updateBlogStatusSucceed,
  requestFailure
} = createActions(
  {
    GET_BLOG_STATUS_STATISTICS_REQUEST: undefined,
    GET_BLOG_STATUS_STATISTICS_SUCCEED: (blogStatistics) => blogStatistics,
    GET_BLOG_LIST_REQUEST: ({ page, limit, q, sortBy, sortDirection }) => ({
      page,
      limit,
      q,
      sortBy,
      sortDirection
    }),
    GET_BLOG_LIST_SUCCEED: (blogList) => blogList,
    GET_BLOG_DETAIL_REQUEST: (blogId) => blogId,
    GET_BLOG_DETAIL_SUCCEED: (blogDetail) => blogDetail,
    CREATE_BLOG_REQUEST: (blogDetail) => blogDetail,
    CREATE_BLOG_SUCCEED: (blogDetail) => blogDetail,
    UPDATE_BLOG_REQUEST: ({ blogId, blogDetail }) => ({
      blogId,
      blogDetail
    }),
    UPDATE_BLOG_SUCCEED: (blogDetail) => blogDetail,
    UPDATE_BLOG_STATUS_REQUEST: ({ blogId, action }) => ({
      blogId,
      action
    }),
    UPDATE_BLOG_STATUS_SUCCEED: (blogDetail) => blogDetail,
    REQUEST_FAILURE: (err) => err
  },
  { prefix: 'BLOG' }
)
